<template>
  <v-dialog v-model="open" max-width="760" persistent scrollable class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="isEdit">
            <span style="color: #2655F1;">编辑</span><span>变压器</span>
          </template>
          <template v-else>
            <span style="color: #2655F1;">新增</span><span>变压器</span>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-0">
        <div class="form-grid-2">
          <div class="form-group">
            <label>产品型号 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.productModel" placeholder="请输入产品型号" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>变压器名称 <span class="required-star">*</span></label>
            <v-text-field v-model="draft.transformerName" placeholder="请输入变压器名称" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>厂家名称</label>
            <v-text-field v-model="draft.manufactorName" placeholder="请输入厂家名称" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>UUID</label>
            <v-text-field v-model="draft.uuid" placeholder="自动生成UUID" variant="flat" density="compact"
              class="gm-input" hide-details readonly />
          </div>
          <div class="form-group">
            <label>设备devID <span class="required-star">*</span></label>
            <v-text-field v-model="draft.devId" placeholder="请输入设备devID" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>出厂编号</label>
            <v-text-field v-model="draft.serialNumber" placeholder="请输入出厂编号" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>出厂时间</label>
            <v-menu v-model="menuVisible" :close-on-content-click="false" location="bottom" offset="8">
              <template #activator="{ props: menuProps }">
                <v-text-field v-bind="menuProps"
                  :model-value="formatTransformerManufactureTime(draft.manufactureTime)"
                  placeholder="请选择出厂时间" variant="flat" density="compact" class="gm-input" hide-details readonly
                  append-inner-icon="mdi-calendar-month-outline" />
              </template>
              <v-date-picker :model-value="manufactureDateValue" color="primary"
                @update:model-value="onDatePicked" />
            </v-menu>
          </div>
          <div class="form-group">
            <label>额定容量（kWh） <span class="required-star">*</span></label>
            <v-text-field v-model="draft.ratedCapacity" placeholder="请输入额定容量" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>电压等级（kV）</label>
            <v-text-field v-model="draft.voltageLevel" placeholder="请输入电压等级" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>输入电压（kV）</label>
            <v-text-field v-model="draft.inputVoltage" placeholder="请输入输入电压" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>输出电压（kV）</label>
            <v-text-field v-model="draft.outputVoltage" placeholder="请输入输出电压" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>绝缘散热介质</label>
            <v-text-field v-model="draft.medium" placeholder="请输入绝缘散热介质" variant="flat" density="compact"
              class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>铁芯结构</label>
            <v-text-field v-model="draft.coreStructure" placeholder="请输入铁芯结构" variant="flat"
              density="compact" class="gm-input" hide-details />
          </div>
          <div class="form-group">
            <label>排序号</label>
            <v-text-field v-model.number="draft.sort" type="number" min="0" placeholder="请输入排序号"
              variant="flat" density="compact" class="gm-input" hide-details />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
          @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="submitting"
          @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { formatTransformerManufactureTime } from '../utils/helpers'

const open = defineModel({ type: Boolean, default: false })
defineProps({
  draft: { type: Object, required: true },
  isEdit: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  manufactureDateValue: { type: [Date, String, Number, Array], default: null },
})
const emit = defineEmits(['close', 'submit', 'date-change'])

// 出厂时间日期弹层——纯 UI 状态，关闭 dialog / 选定日期后同步收起
const menuVisible = ref(false)
watch(open, (v) => {
  if (!v) menuVisible.value = false
})
function onDatePicked(value) {
  emit('date-change', value)
  menuVisible.value = false
}
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
